import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MoviesService } from 'src/app/core/services/movies.service';
import { Comment } from 'src/app/core/interfaces/movie.model';
import { AccountService } from 'src/app/core/services/account.service';
import { Account } from 'src/app/core/interfaces/user.model';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-comments',
  templateUrl: './user-comments.component.html',
  styleUrls: ['./user-comments.component.scss']
})
export class UserCommentsComponent implements OnInit {

  isBrowser: boolean;

  loading = false;
  reviews: Comment[] = [];

  modalReview: any;
  reviewSelected: Comment;

  account: Account;

  constructor(private moviesService: MoviesService,
    private accountService: AccountService,
    @Inject(PLATFORM_ID) platformId,
    private router: Router,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.getAccount();

    if (this.isBrowser) {
      this.modalReview = $('#modalReview');
    }
  }

  openReview(review: Comment) {
    // this.modalReview = $('#modal');
    this.reviewSelected = review;
    this.modalReview.modal('show');
  }

  getAccount() {
    this.accountService.getAccount().then(
      (res: Account) => {
        if (res) {
          this.account = res;

          if (this.account == null) {
            this.router.navigateByUrl('/login');
          }
          else {
            this.loadReviews(); //LLAMADA IMPORTANTE ACA SE CARGA TODO.
          }
        }
      },
      (error) => {
        this.router.navigateByUrl('/login');
      },
    );
  }

  loadReviews() {
    this.loading = true;

    this.moviesService.getCommentsByUser(this.account.id).subscribe((res) => {
      this.reviews = res;

      res.forEach(comment => {
        comment.commentShort = this.shortComment(comment.comment);
      });

    },
      (error) => {

        console.log("ERROR", error);
      },
      () => this.loading = false
    );

  }

  authorFullName(review: Comment) {
    return review.author.firstName + " " + review.author.lastName || "";
  }

  shortComment(comment: string) {

    let maxLength = 1500;
    let minLength = 500;

    let commentLength = Math.floor((Math.random() * (maxLength + 1 - minLength)) + minLength) + 300;
    // console.log(commentLength, comment.length)

    if (commentLength < comment.length) {
      return comment.substring(0, commentLength) + " ...";
    }

    return comment;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.

    if (this.modalReview) this.modalReview.modal('hide');

  }

  closeReview() {
    this.modalReview.modal('hide');
  }

}
